import { getLoginInform } from 'function/login';
import { ROUTER_PATH } from 'types/const';
import { RETURN_YN } from 'types/type';

export default function getRoute() {
  const { adminYn, pltCd } = getLoginInform();
  const routes = [
    {
      name: '모니터링',
      active: true,
      icon: 'desktop',
      children: [
        {
          name: '이천공장',
          to: ROUTER_PATH.sfsh.monitoring.icheon.view,
          active: true
        },
        {
          name: '군산공장',
          to: ROUTER_PATH.sfsh.monitoring.gunsan.view,
          active: true
        }
      ]
    },
    {
      name: '검사결과',
      active: true,
      icon: 'chart-pie',
      children: [
        {
          name: '시료분석 결과(하림)',
          to: ROUTER_PATH.sfsh.inspectResult.sample.list,
          active: true
        },
        {
          name: '성분분석 결과(사협)',
          to: ROUTER_PATH.sfsh.inspectResult.ingredient.list,
          active: true
        },
        {
          name: '동물성단백질 결과(하림)',
          to: ROUTER_PATH.sfsh.inspectResult.protein.list,
          active: true
        },
        {
          name: '위생검사 결과(하림)',
          to: ROUTER_PATH.sfsh.inspectResult.hygiene.list,
          active: true
        }
      ]
    },
    {
      name: '모선정보',
      to: ROUTER_PATH.sfsh.motherShip.list,
      active: true,
      icon: 'info-circle'
    },
    {
      name: 'REPORT',
      active: true,
      icon: 'file-alt',
      children: [
        {
          name: '월말보고서',
          to: ROUTER_PATH.sfsh.report.monthEndReport.list,
          active: true
        },
        {
          name: '주요원료 도입현황',
          to: ROUTER_PATH.sfsh.report.rawMaterial.list,
          active: true
        },
        {
          name: '한계기준 이탈현황',
          to: ROUTER_PATH.sfsh.report.limitStandard.list,
          active: true
        },
        {
          name: '정기심사 브리핑',
          to: ROUTER_PATH.sfsh.report.regularReview.list,
          active: true
        }
      ]
    },

    {
      name: '검사기준정보',
      active: true,
      icon: 'clipboard-check',
      children: [
        {
          name: '검사성분 관리',
          to: ROUTER_PATH.sfsh.inspection.inspectionSetting.list,
          active: true
        },
        {
          name: '검사종류 관리',
          to: ROUTER_PATH.sfsh.inspection.inspectionType.list,
          active: true
        },
        {
          name: '시료기준 관리',
          to: ROUTER_PATH.sfsh.inspection.inspectionGroup.list,
          active: true
        },
        {
          name: '시료정보 관리',
          to: ROUTER_PATH.sfsh.inspection.inspectionInfo.list,
          active: true
        }
      ]
    },
    {
      name: '기준 정보',
      active: true,
      icon: 'tasks',
      children: [
        {
          name: '등록성분량 관리',
          to: ROUTER_PATH.sfsh.standard.ingredient.list,
          active: true
        },
        {
          name: '공정 검사의뢰코드 관리',
          to: ROUTER_PATH.sfsh.standard.process.list,
          active: true
        },
        {
          name: '제품정보',
          to: ROUTER_PATH.sfsh.standard.productionInfo.list,
          active: true
        },
        {
          name: '원료정보',
          to: ROUTER_PATH.sfsh.standard.rawMaterialInfo.list,
          active: true
        }
      ]
    }
  ];

  if (adminYn === RETURN_YN.Y) {
    // 관리자인 경우 속성코드 관리 메뉴 추가
    routes[routes.length - 1].children.splice(0, 0, {
      name: '속성코드 관리',
      to: ROUTER_PATH.standard.code.default,
      active: true
    });

    // 관리자인 경우 사원 관리 메뉴 추가
    routes[routes.length - 1].children.splice(3, 0, {
      name: '사원관리',
      to: ROUTER_PATH.sfsh.standard.employee.list,
      active: true
    });
  } else {
    // 관리자가 아닌 경우 로그인 사용자가 속한 공장만 메뉴에 표시
    // pltCd => 'A110': 이천, 'A120': 군산
    routes[0].children = routes[0].children.filter(
      (value, index) => index === (pltCd === 'A120' ? 1 : 0)
    );
  }

  return routes;
}
